import { getEnv, getMockAddress } from "#/utils/getEnv";

export const APPLICATION = {
  ID: process.env.REACT_APP_ID.replace(/-/g, "_"),
  NAME: `@${process.env.REACT_APP_ID.replace(/-/g, "_").toUpperCase()}`,
  get KONG_URL() {
    const env = getEnv();
    if (env === "mock") {
      return getMockAddress();
    }

    return window.env?.KONG_URL;
  },
  /** Mesma base do KONG_URL, porém apontando para a versão v2 da API */
  get KONG_URL_V2() {
    const env = getEnv();
    if (env === "mock") {
      return getMockAddress();
    }

    return window.env?.KONG_URL?.replace("/api/v1/", "/api/v2/");
  },

  get ENV() {
    return getEnv();
  },
};

export enum PAGE {
  ROOT = "/",
  HOME = "/home",
  DETALHES_VENDA = "/detalhes_produto",
  ESCOLHA_DO_PLANO = "/escolha_plano",
  FAQ = "/faq",
  AGENCIA_CONTA = "/agencia_conta",
  RESUME = "/resumo",
  SIMULATION = "/simulacao",
  TRACKING = "/tracking",
  BOLETO_ADESAO = "/boleto_adesao",
  CONTRATO = "/contrato",
  PROPOSTA_ACEITA = "/proposta_aceita",
  CONTRATO_DETALHES = "/contrato_detalhes",
  MENU_CONSORCIO = "/meu_consorcio",
}
